const paymentHandle = {
  api: {
    payId: 'payId',
    payType: 'payType'
  },
  type: {
    cart: 2,
    buyNow: 1,
  },
  setPayment ({ payId, payType }) {
    const { api, type, getPayment } = this
    const data = JSON.stringify({
      [api.payId]: payId || getPayment()[api.payId],
      [api.payType]: payType || getPayment()[api.payType]
    })
    sessionStorage.setItem('payment', data)
  },
  getPayment () {
    return JSON.parse(sessionStorage.getItem('payment'))
  },
  weChatPay () {
    
   }
}

export default paymentHandle